import { useTitleStore } from 'src/stores/useTitleStore';

const Header = () => {
    const storeTitle = useTitleStore((state) => state.title);

    return (
        <header className="sticky top-0 z-50 -mb-4 w-full bg-white py-2 dark:bg-gray-900">
            <h1 className="relative text-3xl font-semibold tracking-tight sm:text-nowrap">
                <div className="flex items-center gap-4">{storeTitle}</div>
            </h1>
        </header>
    );
};

export default Header;
